import { ExportOutlined } from "@ant-design/icons";
import { theme } from "antd";
import { Footer as AntFooter } from "antd/es/layout/layout";
import Link from "antd/es/typography/Link";
import { useTranslation } from "react-i18next";

const { useToken } = theme;

export const Footer = () => {
  const { token } = useToken();
  const { t } = useTranslation();
  return (
    <AntFooter style={{ padding: "0px 24px 16px 24px" }}>
      {t("footer.brand_name")}{" "}
      {t("footer.copyright", { year: new Date().getFullYear() })}
      <div style={{ float: "right" }}>
        <Link
          href="https://www.superjane.app/legal.html"
          style={{ color: token.colorPrimary }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("footer.legal_notice")} <ExportOutlined />
        </Link>
      </div>
    </AntFooter>
  );
};
